import React from 'react';
import { Switch } from './styles';

/**
 * @param {string} [checked] - for checkbox checked state
 * @param {boolean} [disabled] - whether the checkbox is disabled
 * @param {(e: React.ChangeEvent<HTMLInputElement>) => void} [onChange] - callback when checkbox value changes
 * @param {(e: React.MouseEvent<HTMLInputElement>) => void} [onClick] - callback when checkbox is clicked
 * @param {string} [id] - unique identifier for the checkbox
 * @param {string} [name] - name attribute for the checkbox
 * @param {string} [ariaLabel] - accessibility label for screen readers
 */

interface Props {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  ariaLabel?: string;
}

const SwitchInput: React.FC<Props> = ({
  checked,
  disabled = false,
  onChange,
  onClick,
  id,
  name,
  ariaLabel = 'toggle switch'
}) => {
  return (
    <Switch>
      <label className='switch'>
        <input
          type='checkbox'
          checked={checked}
          onChange={onChange}
          aria-label={ariaLabel}
          onClick={onClick}
          disabled={disabled}
          id={id}
          name={name}
        />
        <span className='slider round'></span>
      </label>
    </Switch>
  );
};

export default SwitchInput;
